<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-alert width="100%" class="pr-2 pl-2" v-if="saveErrorMessage" type="error"> {{ saveErrorMessage }}</v-alert>
            <v-data-table dense class="elevation-1"
                          :headers="headers"
                          :items="luItems"
                          :search="search"
                          item-key="id"
                           :loading="isLoading"
                          :items-per-page="20">

                <template v-slot:[`item.id`]="{ item }">
                    {{ item.id}}

                </template>
                <template v-slot:[`item.description`]="{ item }">
                    {{ item.description}}

                </template>

                <template v-slot:[`item.programName`]="{ item }">
                    {{item.programName}}

                </template>

                <template v-slot:top>
                    <v-toolbar flat>
                        <v-text-field v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            class="ml-1"
                            single-line
                            hide-details
                            clearable
                        />
                        <v-btn class="text-xs ml-2" v-on:click="refresh" color="primary">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog"
                                  max-width="600px">
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn color="primary"
                                       dark
                                       class="mb-2"
                                       v-bind="attrs"
                                       v-on:click="initializeItem">
                                    Add
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-form v-model="isValid">
                                            <v-row>
                                                <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-select :items="programs" 
                                                              :item-text="item =>item.programId +': '+ item.programName"
                                                              label="Program" clearable
                                                              item-value="programId"
                                                              v-model="selectedProgramId">
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="2">
                                                    <v-text-field v-model="editedItem.id" label="Id*" :disabled="editedIndex != -1"
                                                                  :rules="[(v) => !!v || 'Required',(v) =>v.length <= 4 || 'Limited to 4 chars.',]" />
                                                </v-col>

                                                <v-col>
                                                    <v-text-field v-model="editedItem.description" label="Description*"
                                                                  :rules="[(v) => !!v || 'Required',(v) =>v.length <= 50 || 'Limited to 50 chars.',]" />
                                                </v-col>



                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">
                                        Cancel
                                    </v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           :disabled="!isValid"
                                           @click="save">
                                        Add/Update
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                            <v-card>
                                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small
                            class="mr-2"
                            @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small v-if="item.canDelete"
                            @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>

            </v-data-table>

        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/admin/lookupsService";
import { ShowTypeLookupInfo, ProgramLookupInfo } from '@/types/admin/Lookup';

export default Vue.extend({
    name: "ShowTypesMaintenance",
    data: function () {
        return {
            tab: null,
            luItems: [] as ShowTypeLookupInfo[],
            programs: [] as ProgramLookupInfo[],
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: "ID", align: "left", value: "id" },
                { text: "Description", align: "left", value: "description" },
                { text: "Program", align: "left", value: "programName" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                id: "",
                description: "",
                canDelete: true,
                programId: "",
                programName: "",

            },
            defaultItem: {
                id: "",
                description: "",
                canDelete: true,
                programId: "",
                programName: "",
            },
            errorMessage: "",
            isValid: true,
            search: "",
            isLoading: false,
            selectedProgramId: "",
            saveErrorMessage: "",

        };
    },
    created: function () {
        this.reloadItems();
    },
    methods: {
        refresh: function () {
            this.reloadItems();
            this.errorMessage = "";
            this.saveErrorMessage = "";
        },
        reloadItems: function () {
            this.$data.isLoading = true;
            lookupsService.getShowTypesList().then((res: any) => {
                this.luItems = res.showTypes;
                this.programs = res.programs;
                this.$data.isLoading = false;

            });
            this.$data.isLoading = false;
        },
        initializeItem() {
            this.selectedProgramId = "";
            this.dialog = true;

        },

        editItem(item: ShowTypeLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item);
            this.selectedProgramId = this.editedItem.programId;
            this.dialog = true;
        },

        deleteItem(item: ShowTypeLookupInfo) {
            this.editedIndex = this.luItems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            this.errorMessage = "";
            this.saveErrorMessage = "";
            if (!this.editedItem.canDelete) {
                this.closeDelete();
            }
            lookupsService.deleteShowType(this.editedItem.id).then((res) => {
                if (res.success == false) {
                    this.saveErrorMessage = res.messages.join(', ')
                    
                }
                else {
                    this.luItems.splice(this.editedIndex, 1);
                }

                this.reloadItems(); //in case something was changed after that pull

            }).catch((e: any) => {
                this.saveErrorMessage = "Unable to delete the ShowType.";
                return;
            });

            this.closeDelete();


        },

        close() {
            this.errorMessage = "";
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            this.errorMessage = "";
            this.saveErrorMessage = "";
            this.editedItem.id = this.editedItem.id.trim();
            if (this.editedItem.description.trim().length == 0 || this.editedItem.id.length == 0) {
                this.errorMessage = "Please enter valid values."
                return;
            }

            if (!/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/i.test(this.editedItem.id)) {
                this.errorMessage = "Please enter valid values."
                return;
            }

            if (this.editedItem.id.includes(' ')) {
                this.errorMessage = "Please enter valid values."
                return;
            }

            if (this.editedIndex == -1) {
                var exists = this.luItems.find((x: any) => x.id == this.editedItem.id);
                if (exists != null) {
                    this.errorMessage = "This Id already exists.";
                    return;
                }
                
            }
            
            if (this.selectedProgramId != null && this.selectedProgramId.length > 0) {
                var program = this.programs.find((x: any) => x.programId == this.selectedProgramId);
                if (program == null) {
                    this.errorMessage = "Invalid Program"; //possible out of sync
                    return;
                }
                this.editedItem.programName = program.programName;
                this.editedItem.programId = program.programId;
            }
            else {
                this.editedItem.programId = this.selectedProgramId;
                this.editedItem.programName = "";
            }
            
            

            lookupsService.editShowType(this.editedItem)
                .then((res) => {
                    if (res.success) {
                        if (this.editedIndex > -1) {
                            Object.assign(this.luItems[this.editedIndex], this.editedItem)
                        }
                        else {
                            if (this.luItems) {
                                this.luItems.unshift(this.editedItem)

                            }
                        }
                        this.close();
                    }
                    else {
                        this.saveErrorMessage = res.messages.join(', ')
                        this.reloadItems(); //in case something was changed after that pull
                    }
                })
                .catch(this.$handleError)
                .finally(() => this.$store.dispatch("changeLoaderStatus", false));

        },

    },
    computed: {
        formTitle() {
            return this.$data.editedIndex === -1 ? "New Item" : "Edit Item";
        },
    },
    watch: {
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },

});
</script>
